var InvoiceMixin =  {
    data() {
        return {
            labels: {
                due: {
                    label: this.$l10n.__("Restant dû"),
                    labelCount: this.$l10n.__("Factures")
                },
                total: {
                    label : this.$l10n.__("À régler"),
                    labelCount: this.$l10n.__("Factures")
                },
                late: {
                    label: this.$l10n.__("En retard"),
                    labelCount: this.$l10n.__("Factures")
                }
            },
            settingsFormName : 'invoice-setting-form'
        }
    },
}
export default InvoiceMixin;